export default {
      id: "url-usage",
      viewBox: "0 90 612 612",
      url: __webpack_public_path__ + "./images/icons.svg#url",
      toString: function () {
        return this.url;
      }
    }